import { DefaultServicesObj } from "../../../"
import { UserInfo } from "../../../"
import { Payment } from "../../../"
import { QuoteState } from "../../../"


export class ParticipantServiceFamilyDifferences {
    [travellerId: string]: number | undefined
}

export class PriceDifferencesData {
    [familyId: string]: {
        [serviceId: string]: ParticipantServiceFamilyDifferences | number | undefined
    } | undefined
}

export class QuoteResponseDTO {
    constructor(
        public boReference: string,
        public state: QuoteState,
        public payments?: Payment[],
        public userInfo?: UserInfo,
        public booking?: QuoteState | null | undefined,
        public defaultServices?: DefaultServicesObj,
        public paidAmount?: number,
        public remainingAmount?: number,
        public provideId?: string,
        public validUser?: boolean
    ) {
    }
}